import { render, staticRenderFns } from "./ContextHeader.vue?vue&type=template&id=0a821976&"
import script from "./ContextHeader.vue?vue&type=script&lang=js&"
export * from "./ContextHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports